// This logic handles the case where there are compatible products on the sku but not the series
// in that case the "Please select a sku from the dropdowns above..." msg is shown
const hideSelectSkuMsg = () => {
  showHideSelectSkuMsg(false);
};
const showSelectSkuMsg = () => {
  showHideSelectSkuMsg(true);
};
const showHideSelectSkuMsg = bool => {
  var root = document.getElementById("pdp-coveo-compatability-products");
  if (root) {
    var $summarySection = root.querySelectorAll(
      ".legrand-result-summary-section"
    );
    var $facetColumn = root.querySelectorAll(".coveo-facet-column");
    var $resultsColumn = root.querySelectorAll(".coveo-results-column");
    var $dropdownHeaderWrapper = root.querySelectorAll(
      ".coveo-dropdown-header-wrapper"
    );
    var $searchBox = document.getElementById("PDPSearchBox_container");
    var $differentMessage = root.querySelectorAll(
      ".differentCompatibleMessage"
    );

    if (bool) {
      if ($summarySection[0]) $summarySection[0].style.display = "none";
      if ($facetColumn[0]) $facetColumn[0].style.display = "none";
      if ($resultsColumn[0]) $resultsColumn[0].style.display = "none";
      if ($dropdownHeaderWrapper[0])
        $dropdownHeaderWrapper[0].style.display = "none";
      if ($searchBox) $searchBox.style.display = "none";
      if ($differentMessage[0]) $differentMessage[0].style.display = "flex";
    } else {
      if ($summarySection[0]) $summarySection[0].style.display = "flex";
      if ($facetColumn[0]) $facetColumn[0].style.display = "block";
      if ($resultsColumn[0]) $resultsColumn[0].style.display = "block";
      if ($dropdownHeaderWrapper[0])
        $dropdownHeaderWrapper[0].style.display = "inline-flex";
      if ($searchBox) $searchBox.style.display = "block";
      if ($differentMessage[0]) $differentMessage[0].style.display = "none";
    }
  }
};

const ReplaceSearchResultsText = text => {
  var root = document.getElementById("pdp-coveo-compatability-products");
  if (root) {
    var sectionHeader = root.querySelectorAll(".coveo-search-section__header");
    if (sectionHeader) {
      sectionHeader[0].textContent = `${text} Accessories`;
    }
  }
};

const isScreenSizeMobile = () => {
  const overMobileSize = 768;
  return window.innerWidth < overMobileSize;
};

const bodyClickHandler = event => {
  const domEvent = new CustomEvent("vue-body-click", { detail: event });
  document.body.dispatchEvent(domEvent);
};

const mountedBodyClickListener = () => {
  document.body.addEventListener("click", bodyClickHandler);
};
const beforeUnmountBodyClickListener = () => {
  document.body.removeEventListener("click", bodyClickHandler);
};

export default {
  showSelectSkuMsg,
  hideSelectSkuMsg,
  showHideSelectSkuMsg,
  ReplaceSearchResultsText,
  isScreenSizeMobile,
  mountedBodyClickListener,
  beforeUnmountBodyClickListener
};
